import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CmsPostContainerModel } from '../../../../../../models/aggregates/erp/cms-post';
import {
  CmsPostCriteriaModelQuery, CmsPostQueryCriteriaClass
} from '../../../criteria';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';


import { Observable } from 'rxjs';
import { Optional } from 'typescript-optional';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })
export class CmsPostPackageService extends BaseApiPublicLoginTemplateService<
  CmsPostContainerModel,
  CmsPostContainerModel,
  CmsPostContainerModel
> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts';
    this.httpClient = http;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts/' + BaseApiTemplateService.PUBLIC_EP;
  }

  getIncrementedCommentCountBackOffice( postGuid: string, visa: ApiVisa ): Observable<BasicApiResponseModel<CmsPostContainerModel>> {
    let url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments/'
    + 'get-comment-count/' + postGuid + '/'+ 'backoffice-ep';
    
    return this.httpClient.get<BasicApiResponseModel<CmsPostContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getIncrementedCommentCountPublic( postGuid: string, visa: ApiVisa ): Observable<BasicApiResponseModel<CmsPostContainerModel>> {
    let url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments/'
    + 'get-comment-count/' + postGuid + '/'+ 'public-ep';
    
    return this.httpClient.get<BasicApiResponseModel<CmsPostContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getCmsPostByCriteria(
    visa: ApiVisa,
    criteria?: CmsPostQueryCriteriaClass
  ): Observable<ApiResponseModel<CmsPostContainerModel>> {
    const buildDocCriteria = new CmsPostCriteriaModelQuery(criteria);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<CmsPostContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
  updateImage(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + imageGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url + this.endpoint_path + '/replace-file/' + imageGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImage(formData: FormData, extGuid, visa: ApiVisa, postfiletype) {
    let url = this.apiUrl + '/add-files/' + extGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + extGuid;
      if (postfiletype) {
        url += '?' + 'postfiletype=' + postfiletype;
      }
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getExtDetailsByGuid(imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + "/extensions/" + imageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url + this.endpoint_path + "/extensions/" + imageGuid;
    }
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  getImageDetailsByGuid(imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + "/file/" + imageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/file/" + imageGuid;
    }
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  getFileByGuid(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + "/file/" + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/file/" + extGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  static filesToFormData(
    files: File[],
    formDataKeyValue: Optional<string>
  ): FormData {
    let formData = new FormData();
    if (!files || files.length === 0) return formData;
    files.forEach((file) =>
      formData.append(formDataKeyValue.orElse("files"), file)
    );
    return formData;
  }
  private static fileToFormData(
    file: File,
    formDataKeyValue: Optional<string>
  ): FormData {
    return CmsPostPackageService.filesToFormData([file], formDataKeyValue);
  }

  replaceFile(
    file: File,
    fileExtGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<CmsPostContainerModel>> {
    let formData = CmsPostPackageService.fileToFormData(
      file,
      Optional.of("file")
    );
    let url = this.apiUrl + "/replace-file/" + fileExtGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/replace-file/" +
        fileExtGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<CmsPostContainerModel>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  addFile(
    files: File[],
    hdrGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<CmsPostContainerModel>> {
    let formData = CmsPostPackageService.filesToFormData(
      files,
      Optional.of("files")
    );
    let url = this.apiUrl + "/add-files/" + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/add-files/" + hdrGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<CmsPostContainerModel>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }
}
